/* sugar:assets/media-badge.js@2.2.0 */
/*
  Media Badge: [x] closes the badge and Fade after hides it on its own. Both hide every copy of
  the badge at once (the product gallery copies badges onto its slides and rebuilds them when the
  variant changes), so the hide is one rule keyed by the block id rather than a class per copy.
*/
(function () {
  'use strict';

  if (window.__swOk === false || window.__sugarMediaBadge) return;
  window.__sugarMediaBadge = true;

  var hidden = {};

  function hide(id) {
    if (!id || hidden[id]) return;
    hidden[id] = true;
    var sel = '[data-media-badge="' + (window.CSS && CSS.escape ? CSS.escape(id) : id) + '"]';
    var style = document.createElement('style');
    style.textContent =
      sel + '{opacity:0!important;visibility:hidden;pointer-events:none;transition:opacity .4s ease,visibility 0s linear .4s}' +
      '@media (prefers-reduced-motion: reduce){' + sel + '{transition:none}}';
    document.head.appendChild(style);
  }

  function closeFrom(target, event) {
    var x = target && target.closest && target.closest('[data-mb-close]');
    if (!x) return;
    event.preventDefault();
    event.stopPropagation();
    var badge = x.closest('[data-media-badge]');
    if (badge) hide(badge.getAttribute('data-media-badge'));
  }

  // Capture phase: the X wins over a badge link or a badge popup underneath it.
  document.addEventListener('click', function (event) {
    closeFrom(event.target, event);
  }, true);
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' || event.key === ' ') closeFrom(event.target, event);
  }, true);

  /*
    "seen-N" counts from the moment a copy of the badge is first half on screen, so a badge on a
    gallery far down the page is still there when the shopper reaches it. The gallery copies
    badges onto its slides after load, so copies are picked up as they appear.
  */
  var seenTimers = {};
  var seenObserver = null;

  function watchSeen(badge, id, seconds) {
    if (!('IntersectionObserver' in window)) {
      setTimeout(function () { hide(id); }, seconds * 1000);
      seenTimers[id] = true;
      return;
    }
    if (!seenObserver) {
      seenObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var key = el.getAttribute('data-media-badge');
          seenObserver.unobserve(el);
          if (!key || seenTimers[key]) return;
          seenTimers[key] = true;
          var s = parseFloat(String(el.getAttribute('data-fade-after')).replace('seen-', ''));
          setTimeout(function () { hide(key); }, s * 1000);
        });
      }, { threshold: 0.5 });
    }
    seenObserver.observe(badge);
  }

  function watchAllSeen() {
    document.querySelectorAll('[data-fade-after^="seen-"]').forEach(function (badge) {
      var id = badge.getAttribute('data-media-badge');
      var after = parseFloat(String(badge.getAttribute('data-fade-after')).slice(5));
      if (!id || !(after > 0) || seenTimers[id] || badge._mbSeen) return;
      badge._mbSeen = true;
      watchSeen(badge, id, after);
    });
  }

  function startFades() {
    if (window.Shopify && window.Shopify.designMode) return;
    var started = {};
    document.querySelectorAll('[data-fade-after]').forEach(function (badge) {
      var id = badge.getAttribute('data-media-badge');
      var seconds = parseFloat(badge.getAttribute('data-fade-after'));
      if (!id || started[id] || !(seconds > 0)) return;
      started[id] = true;
      setTimeout(function () {
        hide(id);
      }, seconds * 1000);
    });
    if (!document.querySelector('[data-fade-after^="seen-"]')) return;
    watchAllSeen();
    // Copies the gallery adds after load (its carousel and grid rebuilds) are watched as well
    if ('MutationObserver' in window) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        setTimeout(function () {
          pending = false;
          watchAllSeen();
        }, 200);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startFades);
  } else {
    startFades();
  }
})();
